import { Button } from '@shared/ui/button/button';
import React from 'react'
import s from './teacher-sell-card.module.scss'
import { IconBolt } from '@tabler/icons-react';

export const CTA = ({free_first_lesson, first_lesson_discount, teacher_id, isTrial}) => {
	const bookingPath = `/teacher/booking/${teacher_id}`
	if (isTrial) {
		return (
			<Button
				to={bookingPath}
				label="Записаться на пробный урок"
				lefticon={<IconBolt className={s.buttonCTAIcon} />}
				className={s.buttonCTA}
			/>
		)
	}
	return (
		<>
			{free_first_lesson ||
				first_lesson_discount !== 0 ? (
					free_first_lesson ? (
						<Button
							to={bookingPath}
							label="Бесплатный урок"
							lefticon={<IconBolt className={s.buttonCTAIcon} />}
							className={s.buttonCTA}
						/>
					) : (
						<Button
							compact
							to={bookingPath}
							label={"Записаться со скидкой"}
							buttonClassName={s.buttonCTA}
							className={s.buttonCTAWrapper}
						/>
					)
				) : (
					<Button
						compact
						to={bookingPath}
						label={"Записаться на урок"}
						buttonClassName={s.buttonCTA}
						className={s.buttonCTAWrapper}
					/>
				)}
		</>
	)
}
